import React, { useState } from "react";
import moment from "moment";
import { SUBSCRIPTION_VIEW_DATE_FORMAT } from "../../utilities/constants";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";
import "./Subscription.css";
import { useSession } from "../../authentications/SessionContext";


const LOADING_OPTIONS = ["action_pay_current", "action_pay_year"];

const SubscriptionView = ({ handleCloseModal, selectedsubscription }) => {
  const { sessionInfo } = useSession();
  const { context, company_id } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [isLoadingMonth, setIsLoadingMonth] = useState(false);
  const [isLoadingYear, setIsLoadingYear] = useState(false);

  const { package_name, date_start, date_end, state } = selectedsubscription;

  const handlePay = async ({ method }) => {
    if (method === LOADING_OPTIONS[0]) {
      setIsLoadingMonth(true);
    } else {
      setIsLoadingYear(true);
    }

    try {
      const response = await callButtonGeneral({
        args: [selectedsubscription?.id],
        company_id,
        method,
        model: "subscription",
        context: {
          allowed_company_ids: [company_id], 
          lang: "en_US",
          tz: "Asia/Karachi",
          uid: 2,
        },
      });

      if (response.result && response.result.url) {
        window.open(response.result.url, "_blank");
      } else {
        console.error("Unexpected response structure:", response);
      }
    } catch (error) {
      console.error("Error during API call", error);
    }

    if (method === LOADING_OPTIONS[0]) {
      setIsLoadingMonth(false);
    } else {
      setIsLoadingYear(false);
    }
  };
  

  return (
    <div className="subscription-view-container" style={{ width: "900px" }}>
      <div className="modal-header">
        <h5 className="modal-title">{t["Subscription"]}</h5>
        <button
          type="button"
          className="ms-2 mb-2 btn-close"
          onClick={handleCloseModal}
        ></button>
      </div>

      <div className="d-flex justify-content-between">
        <div className="heading_style mb-2 mt-2">{t["Package Name"]}</div>
        <div className="display_data mb-2 mt-2 ">{package_name}</div>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div className="heading_style mb-2 mt-2">{t["Start Date"]}</div>
        <div className="display_data mb-2 mt-2 ">
          {moment(date_start).format(SUBSCRIPTION_VIEW_DATE_FORMAT)}
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div className="heading_style mb-2 mt-2">{t["End Date"]}</div>
        <div className="display_data mb-2 mt-2 ">
          {moment(date_end).format(SUBSCRIPTION_VIEW_DATE_FORMAT)}
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div className="heading_style">{t["State"]}</div>
        <div className="display_data mb-2 mt-2 ">{state}</div>
      </div>
      <hr className="mt-2" />

      {!["free_trial", "paid"].includes(state) && (
        <div className="button-group d-flex justify-content-center align-items-center">
          <button
            className="subscription_buttons d-flex justify-content-center align-items-center"
            disabled={isLoadingMonth}
            onClick={() => handlePay({ method: "action_pay_current" })}
          >
            {isLoadingMonth ? (
              <div className="spinner-border mx-2" role="status"></div>
            ) : (
              ""
            )}
            {t["Pay for current month"]}
          </button>
          <button
            className="subscription_buttons d-flex justify-content-center align-items-center"
            disabled={isLoadingYear}
            onClick={() => handlePay({ method: "action_pay_year" })}
          >
            {isLoadingYear ? (
              <div className="spinner-border mx-2" role="status"></div>
            ) : (
              ""
            )}
            {t["Pay for 1 Year"]}
          </button>
        </div>
      )}
    </div>
  );
};

export default SubscriptionView;
